/* eslint-disable */
/* tslint:disable */

import { LongUserListingResponse, UserResponse, UserSimpleResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

class Users<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Получение списка пользователей
	 * @request GET:/users
	 * @secure
	 */
	usersList = (
		query: {
			/**
			 * part
			 * @format int32
			 */
			part: number;
			/**
			 * elements count
			 * @format int32
			 */
			count: number;
		},
		params: RequestParams = {},
	) =>
		this.request<UserResponse[], void>({
			path: `/users`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Получение списка пользователей БЕЗ АРХИВНЫХ
	 * @request GET:/users/active
	 * @secure
	 */
	activeList = (
		query: {
			/**
			 * part
			 * @format int32
			 */
			part: number;
			/**
			 * elements count
			 * @format int32
			 */
			count: number;
		},
		params: RequestParams = {},
	) =>
		this.request<UserResponse[], void>({
			path: `/users/active`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Получение списка только архивных пользователей
	 * @request GET:/users/archived
	 * @secure
	 */
	archivedList = (
		query: {
			/**
			 * part
			 * @format int32
			 */
			part: number;
			/**
			 * elements count
			 * @format int32
			 */
			count: number;
		},
		params: RequestParams = {},
	) =>
		this.request<UserResponse[], void>({
			path: `/users/archived`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Cписок пользователей в длинном формате
	 * @request GET:/users/long
	 * @secure
	 */
	longList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			org?: number;
			/** колонка для фильтрации */
			filter_column?: string;
			/** значение из колонки для фильтрации */
			filter_value?: string;
			/** null - отобразить всех, true - только активных, false - только архивные */
			filter_active?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<LongUserListingResponse, void>({
			path: `/users/long`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Cписок пользователей в длинном формате (кандидаты на привязку к сотруднику)
	 * @request GET:/users/long/unbound
	 * @secure
	 */
	longUnboundList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			org?: number;
			/** колонка для фильтрации */
			filter_column?: string;
			/** значение из колонки для фильтрации */
			filter_value?: string;
			/** значение из колонки для фильтрации */
			filter_active?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<LongUserListingResponse, void>({
			path: `/users/long/unbound`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Cписок пользователей в кратком формате
	 * @request GET:/users/simple
	 * @secure
	 */
	simpleList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<UserSimpleResponse[], void>({
			path: `/users/simple`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
}
export const usersAPI = new Users();
